<script>

</script>

<div class="d-flex align-items-center justify-content-center py-5 bg-gray" style="height: 100vh;">
    <div class="wrapper">
        <div class="background">
            404
        </div>
        <div class="content">
            <div class="title mb-3">
                Page not found
            </div>
            <div>
                You may have mistyped the address or the page may have moved.
            </div>
        </div>
    </div>
</div>

<style>
    .wrapper {
        position: relative;
        padding: 100px 0;
    }

    .wrapper .background {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-size: 160px;
        font-weight: 600;
        letter-spacing: 14px;
        color: #fff;
        z-index: 1;
    }

    .wrapper .content {
        position: relative;
        z-index: 100;
        text-align: center;
    }

    .wrapper .content .title {
        font-size: 25px;
    }
</style>